import config from "../../config.js";
import axios from "axios";

export async function getAlertCounts() {
  const response = await axios.get(`${config.baseURL}/alert/counts`, {
    withCredentials: true,
  });
  return response.data;
}

export async function getUserAlerts() {
  const response = await axios.get(
    `${config.baseURL}/alert/organization/user`,
    {
      withCredentials: true,
    }
  );
  return response.data;
}

export async function getVehicleAlerts() {
  const response = await axios.get(
    `${config.baseURL}/alert/organization/vehicle`,
    {
      withCredentials: true,
    }
  );
  return response.data;
}

export async function getExpiryAlerts() {
  const response = await axios.get(
    `${config.baseURL}/alert/organization/expiry`,
    {
      withCredentials: true,
    }
  );
  return response.data;
}
// Function to delete an alert
export async function deleteAlertById(alertId) {
  const response = await axios.delete(`${config.baseURL}/alert/delete`, {
    data: { id: alertId },
    withCredentials: true,
  });
  return response.data;
}

//function to update the alert

export async function updateAlert(alertData) {
  try {
    const updatedAlert = await axios.put(`${config.baseURL}/alert`, alertData, {
      withCredentials: true,
    });

    return updatedAlert.data;
  } catch (error) {
    console.error("Failed to update alert:", error);
    throw error;
  }
}

// Function to toggle star status
export async function toggleAlertStar(alertData) {
  try {
    console.log("Making API call to toggle star with payload:", {
      alertId: alertData.id,
      isStarred: alertData.isStarred,
    });
    const response = await axios.patch(
      `${config.baseURL}/alert/starred`,
      {
        alertId: alertData.id,
        isStarred: alertData.isStarred,
      },
      { withCredentials: true }
    );
    console.log("API response:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "Failed to toggle alert star:",
      error.response?.data || error.message
    );
    throw error;
  }
}

// Function to get starred alerts
export async function getStarredAlerts(orgId) {
  try {
    const response = await axios.get(`${config.baseURL}/alert/starred`, {
      params: { organizationId: orgId },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Failed to get starred alerts:", error);
    throw error;
  }
}
